import Cookies from "js-cookie";

export const getToken = () => {
  return `${Cookies.get("_auth_type")} ${Cookies.get("_auth")}`;
};
